import { hp } from "./geom";

const Eyes = ({ c, P }) => (
  <>
    {[-10, 10].map((x) => <g key={x}><ellipse cx={c[0] + x} cy={c[1] - 1} rx="4.2" ry="4.8" fill="#fff" /><circle cx={c[0] + x} cy={c[1]} r="2.6" fill="#16100C" /><circle cx={c[0] + x + 1} cy={c[1] - 1.2} r=".9" fill="#fff" /></g>)}
    <path d={hp(c, [["M", [-15, -10]], ["Q", [-10, -13], [-6, -10]], ["M", [6, -10]], ["Q", [10, -13], [15, -10]]])} stroke="#16100C" strokeWidth="2" fill="none" strokeLinecap="round" />
    <path d={hp(c, [["M", [-3, 6]], ["Q", [0, 9], [3, 6]]])} stroke={P.skinB} strokeWidth="1.8" fill="none" />
    <path d={hp(c, [["M", [-9, 13]], ["Q", [0, 20], [9, 13]]])} stroke={P.skinB} strokeWidth="2.2" fill="none" strokeLinecap="round" />
  </>
);

const Leaves = ({ c, P, profile }) => (
  <g>
    <path d={hp(c, profile ? [["M", [-26, -14]], ["Q", [-4, -40], [22, -22]]] : [["M", [-27, -14]], ["Q", [0, -36], [27, -14]]])} stroke={P.trim} strokeWidth="3" fill="none" />
    {[-3, -2, -1, 0, 1, 2, 3].map((i) => {
      const a = (-90 + i * 24 + (profile ? -10 : 0)) * (Math.PI / 180), x = c[0] + Math.cos(a) * 29, y = c[1] - 8 + Math.sin(a) * 27;
      return <ellipse key={i} cx={x} cy={y} rx="4" ry="9" fill={i % 2 ? P.leaf : "#58B884"} transform={`rotate(${(a * 180) / Math.PI + 90} ${x} ${y})`} />;
    })}
  </g>
);

const FRONT = {
  locs: ({ c, P }) => (<>
    <path d={hp(c, [["M", [-30, -2]], ["C", [-32, -42], [32, -42], [30, -2]], ["C", [18, -22], [-18, -22], [-30, -2]], ["Z"]])} fill={P.hair} />
    {[-24, -16, 16, 24].map((x) => <path key={x} d={hp(c, [["M", [x, -10]], ["q", [x > 0 ? 6 : -6, 12], [x > 0 ? 4 : -4, 24]]])} stroke={P.hair} strokeWidth="6" strokeLinecap="round" fill="none" />)}
  </>),
  puffs: ({ c, P }) => (<>
    {[-1, 1].map((s) => <circle key={s} cx={c[0] + s * 25} cy={c[1] - 28} r="15" fill={P.hair} />)}
    <path d={hp(c, [["M", [-30, -2]], ["C", [-31, -38], [31, -38], [30, -2]], ["C", [18, -20], [-18, -20], [-30, -2]], ["Z"]])} fill={P.hair} />
    {[-1, 1].map((s) => <circle key={s} cx={c[0] + s * 15} cy={c[1] - 21} r="3" fill={P.accent} />)}
  </>),
  headwrap: ({ c, P }) => (<>
    {[-1, 1].map((s) => <path key={s} d={hp(c, [["M", [s * 29, -6]], ["q", [s * 2, 8], [0, 14]]])} stroke={P.hair} strokeWidth="5" strokeLinecap="round" fill="none" />)}
    <path d={hp(c, [["M", [-31, -4]], ["C", [-40, -46], [-20, -70], [0, -70]], ["C", [20, -70], [40, -46], [31, -4]], ["C", [18, -24], [-18, -24], [-31, -4]], ["Z"]])} fill={P.wrap} />
    <path d={hp(c, [["M", [-30, -24]], ["Q", [0, -44], [30, -24]], ["M", [-24, -46]], ["Q", [0, -62], [24, -46]]])} stroke={P.trim} strokeWidth="3" fill="none" />
    <ellipse cx={c[0] + 14} cy={c[1] - 64} rx="11" ry="7" fill={P.wrap} stroke={P.trim} strokeWidth="1.5" />
  </>),
  kufi: ({ c, P }) => (<>
    <path d={hp(c, [["M", [-29, -4]], ["C", [-30, -24], [30, -24], [29, -4]], ["C", [18, -16], [-18, -16], [-29, -4]], ["Z"]])} fill={P.hair} />
    <path d={hp(c, [["M", [-26, -18]], ["L", [-24, -44]], ["Q", [0, -50], [24, -44]], ["L", [26, -18]], ["Q", [0, -24], [-26, -18]], ["Z"]])} fill="#F1E6CF" />
    <path d={hp(c, [["M", [-24, -30]], ["l", [6, -5]], ["l", [6, 5]], ["l", [6, -5]], ["l", [6, 5]], ["l", [6, -5]], ["l", [6, 5]], ["l", [6, -5]], ["l", [6, 5]]])} stroke={P.accent} strokeWidth="2.4" fill="none" />
  </>),
  crown: ({ c, P }) => (<>
    {[-1, 1].map((s) => <path key={s} d={hp(c, [["M", [s * 26, -8]], ["q", [s * 8, 22], [s * 4, 44]]])} stroke={P.hair} strokeWidth="7" strokeLinecap="round" fill="none" strokeDasharray="5 2" />)}
    <path d={hp(c, [["M", [-30, -2]], ["C", [-32, -40], [32, -40], [30, -2]], ["C", [18, -20], [-18, -20], [-30, -2]], ["Z"]])} fill={P.hair} />
    <Leaves c={c} P={P} />
  </>),
};

const Beard = ({ c, P, profile }) => (profile
  ? <path d={hp(c, [["M", [-8, 8]], ["C", [-6, 30], [18, 34], [27, 12]], ["C", [18, 18], [6, 16], [-8, 8]], ["Z"]])} fill={P.hair} />
  : <><path d={hp(c, [["M", [-25, 4]], ["C", [-21, 38], [21, 38], [25, 4]], ["C", [14, 25], [-14, 25], [-25, 4]], ["Z"]])} fill={P.hair} /><path d={hp(c, [["M", [-8, 11]], ["Q", [0, 8], [8, 11]]])} stroke={P.hair} strokeWidth="3.4" strokeLinecap="round" fill="none" /></>);

export const HeadFront = ({ c, ch }) => {
  const P = ch.pal, Hair = FRONT[ch.hair];
  return (
    <g transform={`translate(${c[0]} ${c[1]}) scale(1.14) translate(${-c[0]} ${-c[1]})`}>
      {[-29, 29].map((x) => <ellipse key={x} cx={c[0] + x} cy={c[1] + 2} rx="5" ry="7" fill={P.skinB} />)}
      <circle cx={c[0]} cy={c[1]} r="29" fill={P.skin} />
      <Eyes c={c} P={P} />
      {ch.beard && <Beard c={c} P={P} />}
      {ch.hair === "headwrap" && [-1, 1].map((s) => <circle key={s} cx={c[0] + s * 27} cy={c[1] + 10} r="2.6" fill={P.trim} />)}
      <Hair c={c} P={P} />
    </g>
  );
};

const PROFILE = {
  locs: ({ c, P }) => (<>
    <path d={hp(c, [["M", [-29, 4]], ["C", [-32, -30], [8, -44], [27, -14]], ["C", [10, -22], [-4, -18], [-12, -6]], ["Z"]])} fill={P.hair} />
    {[0, 1, 2, 3].map((i) => <path key={i} d={hp(c, [["M", [-14 - i * 4, -14 + i * 5]], ["q", [-10, 6], [-12, 18]]])} stroke={P.hair} strokeWidth="6" strokeLinecap="round" fill="none" />)}
  </>),
  puffs: ({ c, P }) => (<>
    <circle cx={c[0] - 18} cy={c[1] - 28} r="16" fill={P.hair} />
    <path d={hp(c, [["M", [-29, 4]], ["C", [-32, -30], [8, -42], [26, -14]], ["C", [10, -20], [-4, -16], [-12, -6]], ["Z"]])} fill={P.hair} />
    <circle cx={c[0] - 8} cy={c[1] - 22} r="3" fill={P.accent} />
  </>),
  headwrap: ({ c, P }) => (<>
    <path d={hp(c, [["M", [-14, -6]], ["q", [-4, 8], [-2, 14]]])} stroke={P.hair} strokeWidth="5" strokeLinecap="round" fill="none" />
    <path d={hp(c, [["M", [-30, 6]], ["C", [-42, -40], [-10, -76], [14, -66]], ["C", [30, -58], [32, -30], [26, -14]], ["C", [10, -22], [-6, -18], [-14, -4]], ["Z"]])} fill={P.wrap} />
    <path d={hp(c, [["M", [-32, -20]], ["Q", [-4, -44], [27, -22]], ["M", [-26, -44]], ["Q", [-2, -62], [22, -46]]])} stroke={P.trim} strokeWidth="3" fill="none" />
    <ellipse cx={c[0] - 8} cy={c[1] - 66} rx="12" ry="7" fill={P.wrap} stroke={P.trim} strokeWidth="1.5" />
  </>),
  kufi: ({ c, P }) => (<>
    <path d={hp(c, [["M", [-28, 4]], ["C", [-30, -18], [0, -24], [20, -18]], ["C", [4, -16], [-6, -12], [-12, -4]], ["Z"]])} fill={P.hair} />
    <path d={hp(c, [["M", [-28, -14]], ["L", [-26, -44]], ["Q", [0, -50], [22, -42]], ["L", [24, -16]], ["Q", [0, -24], [-28, -14]], ["Z"]])} fill="#F1E6CF" />
    <path d={hp(c, [["M", [-26, -28]], ["l", [6, -5]], ["l", [6, 5]], ["l", [6, -5]], ["l", [6, 5]], ["l", [6, -5]], ["l", [6, 5]], ["l", [6, -5]], ["l", [6, 5]]])} stroke={P.accent} strokeWidth="2.4" fill="none" />
  </>),
  crown: ({ c, P }) => (<>
    <path d={hp(c, [["M", [-22, -6]], ["q", [-14, 22], [-8, 50]]])} stroke={P.hair} strokeWidth="8" strokeLinecap="round" fill="none" strokeDasharray="5 2" />
    <path d={hp(c, [["M", [-29, 4]], ["C", [-32, -30], [8, -42], [26, -14]], ["C", [10, -20], [-4, -16], [-12, -6]], ["Z"]])} fill={P.hair} />
    <Leaves c={c} P={P} profile />
  </>),
};

export const HeadProfile = ({ c, ch }) => {
  const P = ch.pal, Hair = PROFILE[ch.hair];
  return (
    <g transform={`translate(${c[0]} ${c[1]}) scale(1.14) translate(${-c[0]} ${-c[1]})`}>
      <circle cx={c[0]} cy={c[1]} r="28" fill={P.skin} />
      <path d={hp(c, [["M", [25, -2]], ["q", [8, 5], [1, 10]]])} fill={P.skin} stroke={P.skinB} strokeWidth="1.2" />
      <circle cx={c[0] + 13} cy={c[1] - 5} r="2.8" fill="#16100C" />
      <path d={hp(c, [["M", [8, -12]], ["q", [5, -3], [10, 0]]])} stroke="#16100C" strokeWidth="2" fill="none" strokeLinecap="round" />
      <path d={hp(c, [["M", [8, 12]], ["q", [6, 4], [12, -1]]])} stroke={P.skinB} strokeWidth="2" fill="none" strokeLinecap="round" />
      <ellipse cx={c[0] - 6} cy={c[1] + 2} rx="5" ry="7" fill={P.skinB} />
      {ch.beard && <Beard c={c} P={P} profile />}
      <Hair c={c} P={P} />
    </g>
  );
};

export const HeadBack = ({ c, ch }) => {
  const P = ch.pal, Hair = FRONT[ch.hair];
  const cover = { headwrap: P.wrap, kufi: P.skin }[ch.hair] || P.hair;
  return (
    <g transform={`translate(${c[0]} ${c[1]}) scale(1.14) translate(${-c[0]} ${-c[1]})`}>
      {[-29, 29].map((x) => <ellipse key={x} cx={c[0] + x} cy={c[1] + 2} rx="5" ry="7" fill={P.skinB} />)}
      <circle cx={c[0]} cy={c[1]} r="29" fill={P.skin} />
      <path d={hp(c, [["M", [-30, 6]], ["C", [-34, -40], [34, -40], [30, 6]], ["C", [20, 22], [-20, 22], [-30, 6]], ["Z"]])} fill={ch.hair === "kufi" ? P.hair : cover} />
      <Hair c={c} P={P} />
    </g>
  );
};
